import { Component, h, Prop, State, Element, Watch, Host } from '@stencil/core';
import store, { Filter } from '../../store';
import { getSpecialQuickfilter, isQuickfilterActive } from '../filters';

@Component({
  tag: 'ui-download-search-quickfilter',
  styleUrl: 'ui-download-search-quickfilter.scss',
  shadow: true,
})
export class UiDownloadSearchQuickfilter {
  @Element() el: HTMLElement;

  @Prop() name!: string;

  @Prop() values = '';

  @State() active = false;

  // One Quickfilter can have more than one single filter, that's why we generate them here
  @State() filters: Filter[] = [];

  @State() label = '';

  componentWillLoad() {
    this.filters = this.getFiltersFromValues(this.values);
    this.label = this.el.innerText.trim();
    this.setFundsModeFallback();
    store.onChange('selectedFilters', () => {
      this.active = this.isThisQuickfilterActive();
    });
  }

  private setFundsModeFallback() {
    // The following activates the funds-quickfilter when it's set via URL-params
    if (store.state.currentQuickfilter && isQuickfilterActive(this.filters)) {
      this.active = true;
      const filter = getSpecialQuickfilter('label', this.label);
      store.state.currentQuickfilter = filter;
    }
  }

  private isThisQuickfilterActive(): boolean {
    return (
      store.state.currentQuickfilter?.label === this.label &&
      isQuickfilterActive(this.filters)
    );
  }

  private toggleActive() {
    this.active = !this.active;
    if (this.active) {
      // Check if special quickfilter is available for current filter
      let filter = getSpecialQuickfilter('label', this.label);
      // Otherwise generate dynamic quickfilter
      if (!filter) {
        filter = {
          label: this.label,
          filters: this.filters,
        };
      }
      store.state.currentQuickfilter = filter;
      store.state.selectedFilters = this.filters;
      store.state.tracking.trackAction(
        'DownloadSearchQuickfilterAction',
        this.el.innerText
      );
    } else {
      store.state.currentQuickfilter = null;
      store.state.helpers.removeSelectedFilters(this.filters);
      store.state.tracking.trackAction(
        'DownloadSearchQuickfilterAction',
        this.el.innerText
      );
    }
  }

  @Watch('active')
  setTrackedFilters() {
    store.state.tracking.filters[this.active ? 'add' : 'delete'](this.label);
  }

  private getFiltersFromValues(values) {
    return JSON.parse(values).map((singleValue) => ({ value: singleValue }));
  }

  render() {
    return (
      <Host>
        <button
          class={{ active: this.active }}
          onClick={() => this.toggleActive()}
        >
          <slot></slot>
          {this.active && (
            <ui-icon
              variant="white"
              type="system"
              icon="close-circle"
            ></ui-icon>
          )}
        </button>
      </Host>
    );
  }
}
